export const formatSubscription = (
  subscription: number,
  format: "years" | "months" = "years",
  textSingular?: string,
  textPlural?: string
) => {
  const years = subscription / 12;
  const months = subscription % 12;

  if (format === "years" && months === 0) {
    if (!textPlural || !textSingular) {
      return `${years}`;
    }
    return `${years} ${years === 1 ? textSingular : textPlural}`;
  }

  if (!textPlural || !textSingular) {
    return `${subscription}`;
  }

  return `${subscription} ${subscription === 1 ? textSingular : textPlural}`;
};

export const formatDevices = (
  devices: number,
  textSingular?: string,
  textPlural?: string
) => {
  if (!textPlural || !textSingular) {
    return `${devices}`;
  }
  return `${devices} ${devices === 1 ? textSingular : textPlural}`;
};

